export const baseWords = {
  appBar: {
    title: 'X Pay 管理画面',
    img: 'src',
  },
  shop: {
    table: {
      header: {
        shopName: '店舗名',
        status: 'ステータス',
        externalShopId: '外部店舗ID',
        company: '企業名',
        action: '管理ユーザ登録',
      },
    },
  },
};

export type TWords = Readonly<typeof baseWords>;
